import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigation = [
    { name: 'Accueil', href: '/' },
    { name: 'Nos Photobooths', href: '/photobooths' },
    { name: 'Tarifs', href: '/tarifs' },
    { name: 'Galerie', href: '/galerie' },
    { name: 'Avis', href: '/avis' },
    { name: 'Contact', href: '/contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img
              src="https://customer-assets.emergentagent.com/job_84359d72-7fbf-43ad-8138-bff5ec896218/artifacts/trrith5g_A3BE837C-E2BC-48D9-8E99-A9D1FFBEF393.PNG"
              alt="Captiva Photobooth"
              className="h-16 md:h-20 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  location.pathname === item.href
                    ? 'text-captiva-gold bg-captiva-cream'
                    : isScrolled
                    ? 'text-gray-700 hover:text-captiva-gold hover:bg-captiva-cream'
                    : 'text-gray-800 hover:text-captiva-gold hover:bg-white/10'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-3">
            <a href="tel:0491187506">
              <Button
                variant="outline"
                size="sm"
                className="border-captiva-gold text-captiva-gold hover:bg-captiva-gold hover:text-white transition-all duration-200"
              >
                <Phone className="h-4 w-4 mr-2" />
                Appeler
              </Button>
            </a>
            <Link to="/contact">
              <Button
                size="sm"
                className="bg-captiva-gold hover:bg-captiva-gold-dark text-white transition-all duration-200 shadow-md hover:shadow-lg"
              >
                Réserver
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6 text-gray-900" />
            ) : (
              <Menu className="h-6 w-6 text-gray-900" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 rounded-lg text-base font-medium transition-colors ${
                  location.pathname === item.href
                    ? 'text-captiva-gold bg-captiva-cream'
                    : 'text-gray-700 hover:text-captiva-gold hover:bg-captiva-cream'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="pt-4 space-y-2">
              <a href="tel:0491187506" className="block">
                <Button
                  variant="outline"
                  className="w-full border-captiva-gold text-captiva-gold hover:bg-captiva-gold hover:text-white"
                >
                  <Phone className="h-4 w-4 mr-2" />
                  Appeler maintenant
                </Button>
              </a>
              <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)} className="block">
                <Button className="w-full bg-captiva-gold hover:bg-captiva-gold-dark text-white">
                  Réserver mon photobooth
                </Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
